import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import type {
	IssueViewRelayFragment,
	MainIssueAggQueryRelayFragment,
} from '@atlassian/jira-issue-fetch-services-common/src/services/issue-agg-data/main.tsx';
import type { ui_issueViewRedaction_OnboardingAndFlag_issueViewRelayFragment$key } from '@atlassian/jira-relay/src/__generated__/ui_issueViewRedaction_OnboardingAndFlag_issueViewRelayFragment.graphql';
import type { ui_issueViewRedaction_OnboardingAndFlag_rootRelayFragment$key } from '@atlassian/jira-relay/src/__generated__/ui_issueViewRedaction_OnboardingAndFlag_rootRelayFragment.graphql';
import { RedactionFlag } from './flag/index.tsx';
import { RedactionOnboardingSpotlight } from './onboarding/index.tsx';

type Props = {
	issueViewRelayFragment: IssueViewRelayFragment | null;
	rootRelayFragment: MainIssueAggQueryRelayFragment | null;
};

export const OnboardingAndFlag = ({ issueViewRelayFragment, rootRelayFragment }: Props) => {
	const issue = useFragment<ui_issueViewRedaction_OnboardingAndFlag_issueViewRelayFragment$key>(
		graphql`
			fragment ui_issueViewRedaction_OnboardingAndFlag_issueViewRelayFragment on JiraIssue {
				...onboarding_issueViewRedaction_RedactionOnboardingSpotlight_issue
				...flag_issueViewRedaction_RedactionFlag
			}
		`,
		issueViewRelayFragment || null,
	);

	const root = useFragment<ui_issueViewRedaction_OnboardingAndFlag_rootRelayFragment$key>(
		graphql`
			fragment ui_issueViewRedaction_OnboardingAndFlag_rootRelayFragment on JiraQuery {
				userPreferences(cloudId: $cloudId) @optIn(to: "JiraUserPreferences") {
					...onboarding_issueViewRedaction_RedactionOnboardingSpotlight_user
				}
			}
		`,
		rootRelayFragment?.jira || null,
	);

	if (issue == null || root == null || root.userPreferences == null) {
		return null;
	}

	return (
		<>
			<RedactionFlag issue={issue} />
			<RedactionOnboardingSpotlight issue={issue} user={root.userPreferences} />
		</>
	);
};

const RedactionOnboardingAndFlag = (props: Props) => {
	return (
		<JSErrorBoundary
			id="issue-view-redaction-onboarding-flag"
			packageName="issue-view-redaction-onboarding-flag"
			teamName="JDM - Gunther"
			fallback="unmount"
			sendToPrivacyUnsafeSplunk
		>
			<OnboardingAndFlag {...props} />
		</JSErrorBoundary>
	);
};

export default RedactionOnboardingAndFlag;
